import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation } from "@tanstack/react-query";

const apiClient = createAxiosClient("D365FO");

interface IUpdateSalesOrderPayload {
    customerChanged: boolean;
    orderID: number;
}

async function updateSalesOrder(
    payload: IUpdateSalesOrderPayload,
): Promise<string> {
    const response = await apiClient.post<string>(
        "/FunctionAppsStarter/UpdateSalesOrder",
        {
            orderID: payload.orderID,
            customerChanged: payload.customerChanged,
        },
        { headers: { "Content-Type": "application/json" } },
    );
    return response.data;
}

export function useUpdateSalesOrder() {
    return useMutation({
        mutationFn: updateSalesOrder,
    });
}
